/**
 * תרגום מצבי מערכת בלבד.
 * כל רשימה שהמשתמש עשוי לרצות להרחיב היא טבלה עם מסך ניהול, לא כאן (PRD 2.4).
 * המצבים כאן מוגדרים ב check constraint בבסיס הנתונים, והלוגיקה תלויה בהם.
 */

/**
 * המפתחות הם מה ש schedule_periods.status באמת מכיל (מיגרציה 001).
 *
 * קודם היו כאן draft ו closed, שאינם קיימים בבסיס הנתונים, ולא
 * היו drafting ו archived, שכן. התוצאה היתה שהמצב "בעבודה" הוצג
 * למנהל באנגלית, כפי שנשמר.
 */
export const schedulePeriodStatus = {
  collecting: 'איסוף אילוצים',
  drafting: 'בעבודה',
  published: 'פורסם',
  archived: 'בארכיון',
} as const;

export const swapStatus = {
  open: 'ממתין למתנדב',
  accepted: 'ממתין לאישור מנהל',
  approved: 'אושר',
  rejected: 'נדחה',
  cancelled: 'בוטל',
} as const;

export const applicationStatus = {
  pending: 'ממתין לאישור',
  approved: 'אושר',
  rejected: 'נדחה',
} as const;

export const scope = {
  self: 'עצמו בלבד',
  own_branch: 'הסניף שלו',
  all_branches: 'כל הסניפים',
} as const;

export const smsStatus = {
  queued: 'בהמתנה',
  sent: 'נשלח',
  failed: 'נכשל',
} as const;

/** תווית למצב, עם נפילה חזרה למפתח עצמו אם נוסף מצב חדש בבסיס הנתונים. */
export function label<T extends Record<string, string>>(map: T, key: string | null | undefined) {
  if (!key) return '';
  return map[key] ?? key;
}
